var map = {
	"./ar/label.json": "./src/locale/ar/label.json",
	"./cs/label.json": "./src/locale/cs/label.json",
	"./cy/label.json": "./src/locale/cy/label.json",
	"./da/label.json": "./src/locale/da/label.json",
	"./de/label.json": "./src/locale/de/label.json",
	"./en/label.json": "./src/locale/en/label.json",
	"./es/label.json": "./src/locale/es/label.json",
	"./fi/label.json": "./src/locale/fi/label.json",
	"./fr/label.json": "./src/locale/fr/label.json",
	"./he/label.json": "./src/locale/he/label.json",
	"./hr/label.json": "./src/locale/hr/label.json",
	"./hu/label.json": "./src/locale/hu/label.json",
	"./it/label.json": "./src/locale/it/label.json",
	"./ja/label.json": "./src/locale/ja/label.json",
	"./kk/label.json": "./src/locale/kk/label.json",
	"./ko/label.json": "./src/locale/ko/label.json",
	"./nl/label.json": "./src/locale/nl/label.json",
	"./pl/label.json": "./src/locale/pl/label.json",
	"./pt/label.json": "./src/locale/pt/label.json",
	"./ro/label.json": "./src/locale/ro/label.json",
	"./ru/label.json": "./src/locale/ru/label.json",
	"./sh/label.json": "./src/locale/sh/label.json",
	"./sk/label.json": "./src/locale/sk/label.json",
	"./sr/label.json": "./src/locale/sr/label.json",
	"./sv/label.json": "./src/locale/sv/label.json",
	"./vi/label.json": "./src/locale/vi/label.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/label\\.json$";